import { ActionValidation, StringValidation } from '../../../../../utils/component-validations';
import { on } from '@ember/modifier';
import FlexRow from '../../../layout/flex/row.gjs';
import GhostButton from '../../../action/button/ghost.gjs';
import PrimaryButton from '../../../action/button/primary.gjs';
import Super from '../../../core/base.gjs';

export default class SpdsFeedbackAlertBannerMessageCta extends Super {
  arguments = [new ActionValidation({ optional: ['onPrimaryBtnClick', 'onSecondaryBtnClick'] })];
  baseClass = 'spds-alert-banner-message-cta spds-feedback-alert-banner-message-cta';
  componentName = 'Spds::AlertBanner::Message::Cta';

  constructor() {
    super(...arguments);

    let { onPrimaryBtnClick, onSecondaryBtnClick } = this.args;
    let optional = [];
    let required = [];

    [
      { check: onPrimaryBtnClick, name: 'primaryBtnText' },
      { check: onSecondaryBtnClick, name: 'secondaryBtnText' },
    ].forEach(({ check, name }) => {
      if (check) {
        required.push(name);
      } else {
        optional.push(name);
      }
    });

    this.arguments.push(new StringValidation({ optional, required }));
  }

  get primaryBtnId() {
    return this.composeSubcomponentId('primary-btn');
  }

  get secondaryBtnId() {
    return this.composeSubcomponentId('secondary-btn');
  }

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-alert-banner-message-cta
      data-test-spds-feedback-alert-banner-message-cta
      {{this.validateArguments}}
      ...attributes
    >
      {{#if @onPrimaryBtnClick}}
        <PrimaryButton id={{this.primaryBtnId}} type="button" {{on "click" @onPrimaryBtnClick}}>
          {{@primaryBtnText}}
        </PrimaryButton>
      {{/if}}
      {{#if @onSecondaryBtnClick}}
        <GhostButton id={{this.secondaryBtnId}} type="button" {{on "click" @onSecondaryBtnClick}}>
          {{@secondaryBtnText}}
        </GhostButton>
      {{/if}}
    </FlexRow>
  </template>
}
